import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PERMISSIONS } from '../../../constants';
import { checkPermisson } from '../../../selectors/common';
import { getDownloadedTemplateFile, getPlayersTemplateFile } from '../../../selectors/teams';
import PlayersTemplateFile from '..';
import { aDownloadPlayersTemplatesFile, aGetPlayersTemplateFileRequest, aUploadPlayersTemplateFileRequest } from '../../../reducers';

const mapToProps = (state) => ({
  downloadedTemplateFile: getDownloadedTemplateFile(state),
  playersTemplateFile: getPlayersTemplateFile(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getPlayersTemplateFileRequest: (payload) => dispatch(aGetPlayersTemplateFileRequest(payload)),
  uploadPlayersTemplateFileRequest: (payload) => dispatch(aUploadPlayersTemplateFileRequest(payload),
  ),

  downloadPlayersTemplatesFile: (payload) => dispatch(aDownloadPlayersTemplatesFile(payload)),
});
class SoccerPlayersTemplateFile extends Component {
  constructor(props) {
    super(props);
    this.hasPermissionTo = {
      view: props.checkPermisson(PERMISSIONS.PLAYER_TEMPLATES_FILES_VIEW),
      upload: props.checkPermisson(PERMISSIONS.TEAM_UPLOAD_FILE),
      // download permission is the same as player template list permission
      download: props.checkPermisson(PERMISSIONS.PLAYER_TEMPLATES_VIEW),
    };
  }

  componentDidMount() {
    this.props.getPlayersTemplateFileRequest();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.downloadedTemplateFile !== this.props.downloadedTemplateFile) {
      window.location.assign(this.props.downloadedTemplateFile.url);
    }
  }

  render() {
    return (
      <PlayersTemplateFile
        playersTemplateFile={this.props.playersTemplateFile}
        uploadPlayersTemplateFileRequest={this.props.uploadPlayersTemplateFileRequest}
        hasPermissionToUpload={this.hasPermissionTo.upload}
        hasPermissionToView={this.hasPermissionTo.view}
        hasPermissionToDownload={this.hasPermissionTo.download}
        downloadPlayersTemplatesFile={this.props.downloadPlayersTemplatesFile}
      />
    );
  }
}

export default connect(mapToProps, actionsToProps)(SoccerPlayersTemplateFile);
